import { createClient } from '@/shared/api';
import type { PushStartEcgStreamingQuery, PushStartEcgStreamingQueryVariables } from '@/shared/api';
import PUSH_START_ECG_STREAMING_QUERY from '../queries/pushStartEcgStreaming';

/**
 * Asks the backend to push a start-streaming command to a device so live ECG begins. Runs PUSH_START_ECG_STREAMING_QUERY and throws pushStartEcgStreaming.message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const fetchPushStartEcgStreaming = async (
  input: PushStartEcgStreamingQueryVariables['input'],
): Promise<void> => {
  const client = createClient();
  const result = await client.query<
    PushStartEcgStreamingQuery,
    PushStartEcgStreamingQueryVariables
  >({
    query: PUSH_START_ECG_STREAMING_QUERY,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { pushStartEcgStreaming } = data;
  if (!pushStartEcgStreaming.isSuccess) {
    throw new Error(pushStartEcgStreaming.message ?? undefined);
  }
};

export default fetchPushStartEcgStreaming;
